import React, { useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useExpanded, useTable } from "react-table";
import { Button, Checkbox, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";

import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import NestedTableRow from "./NestedTableRow";
import { toast } from "react-toastify";
import { Menu } from "@material-ui/icons";

const IsDraggingContext = React.createContext(false);

const useStyle = makeStyles({
  itemStatus: {
    color: "#306F9D",
    "&.archive": {
      color: "#962013",
    },
  },
  buttonGroup: {
    textAlign: "left",
    marginTop: "20px",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  draggableTableRow: {
    "&.isDragging": {
      boxShadow: "0px 2px 10px 5px #ccc",
    },
  },
});

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

function formatData(content) {
  const formattedData = content.map((row) => {
    return {
      id: row.id,
      enTitle: row.localizations?.en?.title,
      tcTitle: row.localizations?.tc?.title,
      slug: row.slug || "-",
      visibility: row.visibility,
      comingSoon: row.comingSoon,
      subRows: formatsubRowData(row.children),
    };
  });
  return formattedData;
}

function formatsubRowData(content) {
  if (content.length > 0) {
    const formattedData = content.map((row) => {
      return {
        id: row.id,
        enTitle: row.localizations?.en?.title,
        tcTitle: row.localizations?.tc?.title,
        slug: row.slug,
        visibility: row.visibility,
        comingSoon: row.comingSoon,
      };
    });
    return formattedData;
  }
  return;
}


class DraggableTableCell extends React.Component {
  getSnapshotBeforeUpdate(prevProps) {
    if (!this.ref) {
      return null;
    }

    const isDragStarting =
      this.props.isDragOccurring && !prevProps.isDragOccurring;

    if (!isDragStarting) {
      return null;
    }

    const { width, height } = this.ref.getBoundingClientRect();

    const snapshot = {
      width,
      height,
    };

    return snapshot;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const ref = this.ref;
    if (!ref) {
      return;
    }

    if (snapshot) {
      if (ref.style.width === snapshot.width) {
        return;
      }
      ref.style.width = `${snapshot.width}px`;
      ref.style.height = `${snapshot.height}px`;
      return;
    }

    if (this.props.isDragOccurring) {
      return;
    }

    // inline styles not applied
    if (ref.style.width == null) {
      return;
    }

    // no snapshot and drag is finished - clear the inline styles
    ref.style.removeProperty("height");
    ref.style.removeProperty("width");
  }

  setRef = (ref) => {
    this.ref = ref;
  };

  render() {
    return (
      <TableCell
        style={{
          paddingTop: 6,
          paddingBottom: 6,
          lineHeight: "1.1em",
          height: "48px",
        }}
        ref={this.setRef}
        align={this.props.align}
      >
        {this.props.children}
      </TableCell>
    );
  }
}

const VisibilityCheckbox = ({ index, defaultField, control }) => {
  return (
    <Controller
      control={control}
      name={`menu.${index}.visibility`}
      render={({ field: { value, onChange, ...rest }, fieldState }) => {
        return (
          <Checkbox
            color="primary"
            checked={!!defaultField && defaultField.visibility}
            onChange={(e) => {
              onChange(e.target.checked);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

const ComingSoonCheckbox = ({ index, defaultField, control }) => {
  return (
    <Controller
      control={control}
      name={`menu.${index}.comingSoon`}
      render={({ field: { value, onChange, ...rest }, fieldState }) => {
        return (
          <Checkbox
            color="primary"
            checked={!!defaultField && defaultField.comingSoon}
            onChange={(e) => {
              onChange(e.target.checked);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

function CustomTableRow(props) {
  const { row, className, index, provided, snapshot } = props;
  return (
    <IsDraggingContext.Consumer>
      {(isDragging) => (
        <TableRow
          style={{ background: "white" }}
          className={`${className} ${snapshot.isDragging ? "isDragging" : ""}`}
          key={`customRow-${index}`}
          ref={provided.innerRef}
          isDragging={snapshot.isDragging}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <DraggableTableCell isDragOccurring={isDragging} scope="row">
            <Link
              to={`/hkiff/menu/edit/${row.original.id}`}
              style={{ textDecoration: "none", color: "#306F9D" }}
            >
              {row.cells[0].render("Cell")}
            </Link>
          </DraggableTableCell>
          <DraggableTableCell
            isDragOccurring={isDragging}
            align="left"
            style={{ color: "#306F9D" }}
          >
            {row.cells[1].render("Cell")}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging}>
            {row.cells[2].render("Cell")}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging}>
            {row.cells[3].render("Cell")}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging} align="left">
            {row.cells[4].render("Cell")}
          </DraggableTableCell>
          <DraggableTableCell isDragOccurring={isDragging} align="right">
            {row.cells[5].render("Cell")}
          </DraggableTableCell>
        </TableRow>
      )}
    </IsDraggingContext.Consumer>
  );
}

export default function MenuTable({ disabled, ...props }) {
  const classes = useStyle();
  const { setLoading } = useLoading();
  const [data, setData] = React.useState([]);
  const [defaultValues, setDefaultValues] = React.useState({ menu: [] });
  const [isDragging, setIsDragging] = React.useState(false);
  const [dragProcessing, setDragProcessing] = React.useState(false);

  React.useLayoutEffect(() => {
    if (dragProcessing) setDragProcessing(false);
  }, [dragProcessing]);

  const {
    control,
    handleSubmit,
    watch,
    reset,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  const { fields, move } = useFieldArray(
    {
      control,
      name: "menu",
    }
  );

  const watchFieldArray = watch("menu");
  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });

  const columns = React.useMemo(
    () => [
      {
        Header: "Title (English)",
        accessor: "enTitle",
      },
      {
        Header: "Title (Traditional)",
        accessor: "tcTitle",
      },
      {
        Header: "Visibility",
        accessor: "visibility",
        Cell: ({ row }) => {
          return (
            <VisibilityCheckbox
              index={row.index}
              defaultField={data[row.index]}
              control={control}
            />
          );
        },
      },
      {
        Header: "Coming Soon",
        accessor: "comingSoon",
        Cell: ({ row }) => {
          return (
            <ComingSoonCheckbox
              index={row.index}
              defaultField={data[row.index]}
              control={control}
            />
          );
        },
      },
      {
        Header: "Slug",
        accessor: "slug",
      },
      {
        Header: "",
        id: "icon",
        Cell: () => {
          return <Menu fontSize="small" style={{ color: "#CCCCCC" }} />;
        },
      },
    ],
    [control, data]
    // []
  );

  const defaultExpandedRows = [];
  for (let index = 0; index < 10; index++) {
    defaultExpandedRows.push({ index: true });
  }

  const { getTableProps, headerGroups, rows, prepareRow, toggleRowExpanded } =
    useTable(
      {
        columns,
        data,
        initialState: {
          pageIndex: 0,
          expanded: defaultExpandedRows,
        },
        expandSubRows: false,
      },
      useExpanded
    );

  const getMenu = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getHkiffMenu();
      const processedData = formatData(result.data);
      setData(processedData);
      setDefaultValues({ menu: processedData });
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  }, [setLoading]);

  const updateMenus = async (data) => {
    try {
      const result = await apiHelper.hkiff.updateHkiffMenus(data);
      if (result.status === 200) {
        toast.dark("Your changes is saved.");
        await getMenu();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const formatRequestData = (values) => {
    return {
      status: values.menu
        .map((value) => {
          let statuses = [
            {
              id: value.id,
              visibility: value.visibility,
              comingSoon: value.comingSoon,
            },
          ];
          if (value.subRows) {
            value.subRows.forEach((subRow) => {
              subRow.id &&
                statuses.push({
                  id: subRow.id,
                  visibility: subRow.visibility,
                  comingSoon: subRow.comingSoon,
                });
            });
          }
          return statuses;
        })
        .flat(),
      seq: data
        .map((value) => {
          const subRowIds = [];
          if (value.subRows) {
            value.subRows.forEach((subRow) => subRowIds.push(subRow.id));
          }
          return [value.id, ...subRowIds];
        })
        .flat(),
    };
  };

  const onSubmit = (values) => {
    const requestData = formatRequestData(values);
    updateMenus(requestData);
  };

  const onBeforeCapture = (beforeCapture) => {
    toggleRowExpanded(beforeCapture.draggableId, false);
  };

  const onBeforeDragStart = () => {
    setIsDragging(true);
  };

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      controlledFields,
      result.source.index,
      result.destination.index
    );
    move(result.source.index, result.destination.index);
    setData(items);
    toggleRowExpanded(result.destination.index, true);
    setDragProcessing(true);
  };

  useEffect(() => {
    getMenu();
  }, [getMenu]);

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  return (
    <>
      <Typography variant="h4" gutterBottom>
        Menu
      </Typography>
      <IsDraggingContext.Provider value={isDragging}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset disabled={disabled} className="fieldset">
            <Paper>
              <Table aria-label="simple table" {...getTableProps()}>
                <TableHead component="div">
                  {headerGroups.map((headerGroup) => (
                    <TableRow {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column) => (
                        <TableCell
                          {...column.getHeaderProps()}
                          style={{
                            paddingTop: 6,
                            paddingBottom: 6,
                            lineHeight: "1.1em",
                            height: "48px",
                          }}
                        >
                          {column.render("Header")}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableHead>
                {dragProcessing || (
                  <DragDropContext
                    onBeforeDragStart={onBeforeDragStart}
                    onDragEnd={onDragEnd}
                    onBeforeCapture={onBeforeCapture}
                  >
                    <Droppable droppableId="parentMenu" type="MENU">
                      {(provided, snapshot) => (
                        <TableBody
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {defaultValues.menu.length > 0 &&
                            rows.map((row, index) => {
                              prepareRow(row);
                              const rowProps = row.getRowProps();
                              return (
                                <>
                                  <Draggable
                                    key={row.id}
                                    draggableId={row.id}
                                    index={index}
                                    isDragDisabled={disabled}
                                  >
                                    {(provided, snapshot) => (
                                      <CustomTableRow
                                        className={classes.draggableTableRow}
                                        key={`parentRow-${row.id}`}
                                        row={row}
                                        index={index}
                                        control={control}
                                        field={fields[`${index}`]}
                                        provided={provided}
                                        snapshot={snapshot}
                                      />
                                    )}
                                  </Draggable>
                                  {row.subRows &&
                                    row.isExpanded &&
                                    controlledFields[`${index}`]?.subRows && (
                                      <NestedTableRow
                                        {...rowProps}
                                        row={row}
                                        index={index}
                                        control={control}
                                        field={controlledFields[`${index}`].subRows}
                                        draggableProps={provided.draggableProps}
                                      />
                                    )}
                                </>
                              );
                            })}
                          {provided.placeholder}
                        </TableBody>
                      )}
                    </Droppable>
                  </DragDropContext>
                
                )}
              </Table>
            </Paper>
            {disabled || (
              <div className={classes.buttonGroup}>
                <Button
                  type="submit"
                  variant="contained"
                  disableElevation
                  style={{
                    color: "white",
                    background: "#306F9D",
                    marginRight: "5px",
                    padding: "9px 16px",
                  }}
                >
                  Save Changes
                </Button>
              </div>
            )}
          </fieldset>
        </form>
      </IsDraggingContext.Provider>
    </>
  );
}
